let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("h6luW")).then(() => parcelRequire('2Z7LQ'));